import React from 'react';

interface SiteNavProps {
  currentPage: 'home' | 'about' | 'contact';
  onScrollToWaitlist?: () => void;
}

const SiteNav: React.FC<SiteNavProps> = ({ currentPage, onScrollToWaitlist }) => {
  const isHome = currentPage === 'home';

  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    if (isHome) {
      e.preventDefault();
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
    // On sub-pages, let the browser navigate to /#id naturally
  };

  return (
    <nav className="nav">
      <div className="nav-container">
        <a href="/" className="nav-logo" style={{ textDecoration: 'none', color: 'inherit' }}>
          <img src="/ElevenUpLogo.png" alt="ElevenUp" className="nav-logo-img" />
          <span className="nav-logo-text">ElevenUp</span>
        </a>
        <div className="nav-links">
          <a
            href={isHome ? '#how-it-works' : '/#how-it-works'}
            className="nav-link"
            onClick={(e) => handleAnchorClick(e, 'how-it-works')}
          >
            How It Works
          </a>
          <a
            href={isHome ? '#subjects' : '/#subjects'}
            className="nav-link"
            onClick={(e) => handleAnchorClick(e, 'subjects')}
          >
            Subjects
          </a>
          <a href="/about" className={`nav-link${currentPage === 'about' ? ' nav-link-active' : ''}`}>
            About
          </a>
          <a href="/blog" className="nav-link">
            Blog
          </a>
          {isHome ? (
            <button className="nav-cta" onClick={onScrollToWaitlist}>
              Get Early Access
            </button>
          ) : (
            <a href="/#waitlist" className="nav-cta" style={{ textDecoration: 'none' }}>
              Get Early Access
            </a>
          )}
        </div>
      </div>
    </nav>
  );
};

export default SiteNav;
